<div class="google-adsense-container" [ngStyle]="{'width': width+'px', 'height': height+'px'}">
  <ng-adsense *ngIf="credits && credits.bigCredits == 0"
              [width]="width"
              [height]="height">
  </ng-adsense>
</div>
